export const getString = (value: unknown, fallback = "") =>
  typeof value === "string" ? value : fallback;

export const getStringArray = (value: unknown, fallback: string[] = []) =>
  Array.isArray(value) ? value.filter((item): item is string => typeof item === "string") : fallback;

export const getRecord = <T extends Record<string, unknown>>(value: unknown, fallback: T): T => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return fallback;
  }

  return {
    ...fallback,
    ...(value as Partial<T>),
  } as T;
};

export const getRecordArray = <T extends Record<string, unknown>>(value: unknown, fallback: T[]): T[] =>
  Array.isArray(value)
    ? (value.filter((item): item is T => Boolean(item) && typeof item === "object" && !Array.isArray(item)) as T[])
    : fallback;
